import { useEffect, useState } from "react";

const STORAGE_KEY = "request-edit:chat-height";

function readStoredHeight(): null | number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);

    if (!raw) return null;

    const parsed = Number(raw);

    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
}

function persistHeight(height: null | number) {
  try {
    if (height === null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, String(height));
    }
  } catch {}
}

export function usePersistedChatHeight() {
  const [chatHeight, setChatHeight] = useState<null | number>(() =>
    readStoredHeight(),
  );

  useEffect(() => {
    persistHeight(chatHeight);
  }, [chatHeight]);

  return [chatHeight, setChatHeight] as const;
}
